import "./AboutPage.css";
import Avatar from '../Images/Engineeringabt.jpeg'
import Avatar1 from '../Images/s1.jpeg'
import Footer from "../Component/NewFooter";

/* ══════════════════════════════
   DATA
══════════════════════════════ */
// const ncecServices = [
//   { id: 1, label: "Facility for Threading of Pipes & Machine Shop Services",           angle: 270 },
//   { id: 2, label: "Facility for Assembly Testing Repair & Maintenance of Valves",      angle: 342 },
//   { id: 3, label: "Facility for Assembly & Maintenance of Pumps, Compressors & Other Rotating Equipment", angle: 54  },
//   { id: 4, label: "Facility for Fabrication & Assembly of Hoses",                      angle: 126 },
//   { id: 5, label: "Facility for Prefabrication of GRE, GRP, GRVE & Composite Pipes",  angle: 198 },
// ];

/* ══════════════════════════════
   SUB-COMPONENTS
══════════════════════════════ */

/* ── 1. About Us ── */
function AboutUs() {
  return (
    <section className="about-us">
      <div className="about-us__header">
        <h2 className="section-title">About Us</h2>
        <span className="section-divider" />
      </div>

      <div className="about-us__body">
        {/* Image with gold accent */}
        <div className="about-us__img-wrap">
          <div className="about-us__img-accent" />
          <img
            src={Avatar}
            alt="Offshore oil platform with workers"
            className="about-us__img"
          />
        </div>

        {/* Text */}
        <div className="about-us__text">
          <div className="about_us_trans">
          <h2>
            Jeyshawn Engineering Limited is a leading indigenous Engineering, Procurement, Construction, Installation, and Commissioning (EPCIC) company dedicated to providing high-quality engineering and technical solutions to the oil & gas, energy, marine, manufacturing, and infrastructure sectors.
          </h2>
          <p>
            Established with a commitment to excellence and innovation, we have built a reputation for delivering complex projects with precision, efficiency, and professionalism. Our company was founded on the principle of creating dependable engineering solutions that support industrial development, operational growth, and sustainable progress across various sectors of the economy.
          </p>
          <p>
           With years of combined industry experience, our management team and technical professionals possess the expertise required to handle challenging projects in both onshore and offshore environments. We continuously invest in modern technologies, workforce development, and operational systems that enable us to deliver exceptional services that align with international best practices and client expectations.
          </p>
          <p>
            At Jeyshawn Engineering Limited, we understand that successful project delivery requires more than technical knowledge. It requires strategic planning, innovation, collaboration, effective communication, and an unwavering commitment to quality and safety. This understanding drives our approach to every project we undertake.
          </p>
          <p>
            Our integrated EPCIC solution covers the entire project lifecycle from initial planning, engineering studies, and procurement to construction, installation, commissioning, operations support, and maintenance services. By providing comprehensive solutions under one platform, we help our clients minimize operational risks, improve efficiency, reduce project timelines and maximize value.
          </p>
          </div>
        </div>
      </div>
    </section>
  );
}


/* ── 3. Integrated Management System Policy ── */
function IMSPolicy() {
  return (
    <section className="ims-policy">
      <div className="ims-policy__inner">
        <h2 className="ims-policy__title">
          OUR MISSION
        </h2>
        <p className="ims-policy__text">
         At Jeyshawn, our mission is to execute projects safely, on time, and within budget, while exceeding client's expectations through engineering excellence, operational efficiency, and technological innovations.
        </p>
        {/* <a href="#" className="ims-policy__btn" download>
          DOWNLOAD POLICY
        </a> */}
      </div>
      <div className="ims-policy__inner">
        <h2 className="ims-policy__title">
          OUR VISION
        </h2>
        <p className="ims-policy__text">
         To be the most trusted partner in delivering world-class EPCIC solutions for sustainable and efficient energy infrastructure.
        </p>
        {/* <a href="#" className="ims-policy__btn" download>
          DOWNLOAD POLICY
        </a> */}
      </div>
    </section>
  );
}

/* ══════════════════════════════
   MAIN EXPORT
══════════════════════════════ */
export default function AboutPage() {
  return (
    <div className="about_bg_color">
      <div className="img_carrier">
        <img src={Avatar1} alt="" />
      </div>
    
    <div className="about-page">
      <AboutUs />
      {/* <NcecDiagram /> */}
      <IMSPolicy />
    </div>
    <Footer />
    </div>
  );
}